/**
 * EdgeLexNodeRegistry.ts
 * 
 * Core Lexical node registry and theme for EdgeLex DMS
 * Phase 1: Essential nodes only
 */

import { ParagraphNode, TextNode, LineBreakNode } from 'lexical';
import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { ListNode, ListItemNode } from '@lexical/list';
import { LinkNode, AutoLinkNode } from '@lexical/link';
import { TableNode, TableCellNode, TableRowNode } from '@lexical/table';
import { CodeNode, CodeHighlightNode } from '@lexical/code';
import { MarkNode } from '@lexical/mark';
import { CACaptionNode } from '../nodes/CACaptionNode';
import { SoftPageBreakNode } from '../nodes/SoftPageBreakNode';
// import { PageBreakNode } from '../plugins/PageBreakPlugin';
/**
 * Core Lexical nodes supported by EdgeLex
 */
export const EdgeLexNodeRegistry = [
  // Core nodes
  ParagraphNode,
  TextNode,
  LineBreakNode,
  
  // Rich text
  HeadingNode,
  QuoteNode,
  MarkNode,
  
  // Lists
  ListNode,
  ListItemNode,
  
  // Links
  LinkNode,
  AutoLinkNode,
  
  // Tables
  TableNode,
  TableCellNode,
  TableRowNode,
  
  // Code
  CodeNode,
  CodeHighlightNode,
  
  // Document layout
  // PageBreakNode, // REMOVED
  CACaptionNode,
  SoftPageBreakNode,
];

/**
 * Basic theme for legal documents
 */
export const EdgeLexLegalTheme = {
  paragraph: 'text-base text-gray-900 leading-relaxed mb-2',
  heading: {
    h1: 'text-2xl font-bold text-gray-900 mb-4',
    h2: 'text-xl font-semibold text-gray-900 mb-3',
    h3: 'text-lg font-medium text-gray-900 mb-2',
  },
  list: {
    nested: {
      listitem: 'list-item ml-4',
    },
    ol: 'list-decimal list-inside ml-4',
    ul: 'list-disc list-inside ml-4',
  },
  link: 'text-lex-accent underline hover:text-lex-accent-hover',
  quote: 'border-l-4 border-gray-300 pl-4 italic text-gray-700 bg-gray-50 py-2',
  code: 'bg-gray-100 rounded px-2 py-1 font-mono text-sm',
  text: {
    bold: 'font-bold',
    italic: 'italic',
    underline: 'underline',
    strikethrough: 'line-through',
    code: 'bg-gray-100 rounded px-1 font-mono text-sm',
  },
};